import { render, staticRenderFns } from "./PasoUno.vue?vue&type=template&id=2f9edb61"
import script from "./PasoUno.vue?vue&type=script&lang=js"
export * from "./PasoUno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports